// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2837":"0549e01a","4084":"0549e01a","5598":"34acb6a4"}[chunkId] + ".chunk.css";
};